/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useRef, useState } from "react";
import angleDown from "../assets/images/angle_up_down.svg";
import imagedrage from "../assets/images/model/image-icon.svg";
import checkmarkSaved from "../assets/images/model/checkmark_saved.svg";
import video from "../assets/images/model/video_icon.svg";
import audioIcon from "../assets/images/model/audio-icon.svg";
import plusCricle from "../assets/images/model/plus-addmedia.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
import close from "../assets/images/close-circle.svg";
import checkBox from "../assets/images/check_box.svg";
import "react-h5-audio-player/lib/styles.css";
import "./questionstypes.css";
import ImageUploadQ from "../Pages/Book/questionTypeMedia/ImageUploadQ";
import AudioUploadQ from "../Pages/Book/questionTypeMedia/AudioUploadQ";
import VideoUploadQ from "../Pages/Book/questionTypeMedia/VideoUploadQ";

const MultiSelectOption = ({
  questionMuliSelect,
  setQuestionMultiSelect,
  isEditing,
  index,
}) => {
  const isS3Url = (url) => {
    return url.includes("s3.amazonaws.com");
  };

  const isYouTubeUrl = (url) => {
    return url.includes("youtube.com") || url.includes("youtu.be");
  };
  const audioRef = useRef();
  const [textareaHeights, setTextareaHeights] = useState(
    questionMuliSelect.map((question) => question.options.map(() => 40))
  );
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [showAudioUploadModal, setShowAudioUploadModal] = useState(false);
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(null);

  /* Long option */
  const getTextLengthClass = (text) => {
    return text.length > 30 ? "long_option" : "short_option";
  };

  /*  */
  const handleInputChange = (e, questionIndex, optionIndex) => {
    const { value } = e.target;

    // Update textarea height if necessary
    const textarea = e.target;
    textarea.style.height = "auto";
    const newHeight = textarea.scrollHeight;
    textarea.style.height = `${newHeight}px`;

    setTextareaHeights((prevHeights) => {
      const newHeights = [...prevHeights];
      newHeights[questionIndex][optionIndex] = newHeight;
      return newHeights;
    });

    // Update text value in questionss
    setQuestionMultiSelect((oldQuestions) =>
      oldQuestions.map((question, index) =>
        index === questionIndex
          ? {
              ...question,
              options: question.options.map((option, oi) =>
                oi === optionIndex ? { ...option, text: value } : option
              ),
            }
          : question
      )
    );
  };

  const getDragHandleHeight = (optionType, currentHeight) => {
    const defaultHeights = {
      text: 40,
      image: 148,
      video: 148,
      audio: 115,
    };
    const defaultHeight = defaultHeights[optionType] || 148;

    return defaultHeight + Math.max(currentHeight - 40, 0);
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;

    setQuestionMultiSelect((oldQuestions) => {
      const copiedQuestions = [...oldQuestions];
      const sourceQuestion = copiedQuestions[source.droppableId];

      if (source.droppableId === destination.droppableId) {
        const reorderedOptions = Array.from(sourceQuestion.options);
        const [removed] = reorderedOptions.splice(source.index, 1);
        reorderedOptions.splice(destination.index, 0, removed);
        sourceQuestion.options = reorderedOptions;
      } else {
        return oldQuestions;
      }

      return copiedQuestions;
    });
  };

  /* Upload Media to Options */
  const handleImageOptionClick = (questionIndex, optionIndex) => {
    setSelectedQuestionIndex(questionIndex);
    setSelectedOptionIndex(optionIndex);
    setShowImageUploadModal(true);
  };
  const handleAudioOptionClick = (questionIndex, optionIndex) => {
    setSelectedQuestionIndex(questionIndex);
    setSelectedOptionIndex(optionIndex);
    setShowAudioUploadModal(true);
  };
  const handleVideoOptionClick = (questionIndex, optionIndex) => {
    setSelectedQuestionIndex(questionIndex);
    setSelectedOptionIndex(optionIndex);
    setShowVideoUploadModal(true); // Show video modal
  };
  const handleImageUploaded = (imageFile) => {
    const updatedQuestions = questionMuliSelect.map((question, qIndex) => {
      if (qIndex === selectedQuestionIndex) {
        return {
          ...question,
          options: question.options.map((option, oIndex) =>
            oIndex === selectedOptionIndex ? { ...option, imageFile } : option
          ),
        };
      }
      return question;
    });

    setQuestionMultiSelect(updatedQuestions);
    setShowImageUploadModal(false);
    setSelectedQuestionIndex(null);
    setSelectedOptionIndex(null);
  };

  const handleAudioUploaded = (audioFile) => {
    const updatedQuestions = questionMuliSelect.map((question, qIndex) => {
      if (qIndex === selectedQuestionIndex) {
        return {
          ...question,
          options: question.options.map((option, oIndex) =>
            oIndex === selectedOptionIndex ? { ...option, audioFile } : option
          ),
        };
      }

      return question;
    });

    setQuestionMultiSelect(updatedQuestions);
    setShowAudioUploadModal(false);
    setSelectedQuestionIndex(null);
    setSelectedOptionIndex(null);
  };

  const handleVideoUploaded = (videoUrl) => {
    const updatedQuestions = questionMuliSelect.map((question, qIndex) => {
      if (qIndex === selectedQuestionIndex) {
        return {
          ...question,
          options: question.options.map((option, oIndex) =>
            oIndex === selectedOptionIndex
              ? { ...option, videoFile: videoUrl }
              : option
          ),
        };
      }
      return question;
    });

    setQuestionMultiSelect(updatedQuestions);
    setShowVideoUploadModal(false);
    setSelectedQuestionIndex(null);
    setSelectedOptionIndex(null);
  };

  /* ......................... */

  /* For Audio Source */
  const formatTime = (time) => {
    if (!time) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {questionMuliSelect.map((question, questionIndex) => (
        <div key={questionIndex}>
          {question.type === "multi select" && (
            <Droppable droppableId={questionIndex.toString()} type="OPTIONS">
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={`${"save_state_mcqs"}`}
                >
                  {question.options.map((option, optionIndex) => (
                    <Draggable
                      key={option.order}
                      draggableId={`${questionIndex}-${option.order}`}
                      index={optionIndex}
                      isDragDisabled={!isEditing}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className={`orderlist-item ${
                            !isEditing
                              ? "save_state_border save_option_width"
                              : "border_none"
                          } ${getTextLengthClass(option.text)}`}
                        >
                          {isEditing ? (
                            <>
                              <RenderEditOption
                                provided={provided}
                                option={option}
                                questionIndex={questionIndex}
                                optionIndex={optionIndex}
                                textareaHeights={textareaHeights}
                                handleInputChange={handleInputChange}
                                handleImageOptionClick={handleImageOptionClick}
                                handleAudioOptionClick={handleAudioOptionClick}
                                handleVideoOptionClick={handleVideoOptionClick}
                                getDragHandleHeight={getDragHandleHeight}
                                isS3Url={isS3Url}
                                isYouTubeUrl={isYouTubeUrl}
                                formatTime={formatTime}
                                audioRef={audioRef}
                              />
                              <div className="check_cros_img">
                                <div
                                  style={{
                                    position: "relative",
                                    right: "9px",
                                    width: "24px",
                                    height: "24px",
                                  }}
                                >
                                  {option.isCorrect && (
                                    <img
                                      src={close}
                                      alt="unselect"
                                      onClick={() => {
                                        setQuestionMultiSelect((old) =>
                                          old.map((q, qi) =>
                                            qi === questionIndex
                                              ? {
                                                  ...q,
                                                  options: q.options.map(
                                                    (o, oi) =>
                                                      oi === optionIndex
                                                        ? {
                                                            ...o,
                                                            isCorrect: false,
                                                          }
                                                        : o
                                                  ),
                                                }
                                              : q
                                          )
                                        );
                                      }}
                                    />
                                  )}
                                </div>

                                <img
                                  className={`check_true cursor ${
                                    option.isCorrect ? "correct-option" : ""
                                  }`}
                                  src={checkBox}
                                  alt="select"
                                  value={option.text}
                                  onClick={() => {
                                    setQuestionMultiSelect((old) =>
                                      old.map((q, qi) =>
                                        qi === questionIndex
                                          ? {
                                              ...q,
                                              options: q.options.map((o, oi) =>
                                                oi === optionIndex
                                                  ? { ...o, isCorrect: true }
                                                  : o
                                              ),
                                            }
                                          : q
                                      )
                                    );
                                  }}
                                />
                              </div>
                            </>
                          ) : (
                            <>
                              <RenderSavedOption
                                provided={provided}
                                option={option}
                                questionIndex={questionIndex}
                                optionIndex={optionIndex}
                                textareaHeights={textareaHeights}
                                handleImageOptionClick={handleImageOptionClick}
                                handleAudioOptionClick={handleAudioOptionClick}
                                handleVideoOptionClick={handleVideoOptionClick}
                                getDragHandleHeight={getDragHandleHeight}
                                isS3Url={isS3Url}
                                isYouTubeUrl={isYouTubeUrl}
                                formatTime={formatTime}
                                audioRef={audioRef}
                                isEditing={isEditing}
                              />
                              {option.isCorrect && (
                                <img
                                  className="image_save_tick"
                                  src={checkmarkSaved}
                                  alt="check"
                                  value={option.text}
                                />
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          )}
        </div>
      ))}
      {showImageUploadModal && (
        <ImageUploadQ
          onImageUploadedQ={handleImageUploaded}
          setUploadImageShow={setShowImageUploadModal}
        />
      )}
      {showAudioUploadModal && (
        <AudioUploadQ
          onAudioUploadedQ={handleAudioUploaded}
          setShowAudioUploadModal={setShowAudioUploadModal}
        />
      )}
      {showVideoUploadModal && (
        <VideoUploadQ
          onAudioUploadedQ={handleVideoUploaded}
          setShowVideoUploadModal={setShowVideoUploadModal}
        />
      )}
    </DragDropContext>
  );
};
const RenderEditOption = ({
  option,
  questionIndex,
  optionIndex,
  textareaHeights,
  handleInputChange,
  handleImageOptionClick,
  handleAudioOptionClick,
  handleVideoOptionClick,
  isS3Url,
  isYouTubeUrl,
  formatTime,
  audioRef,
}) => {
  return (
    <>
      <div className="parent_input_with_image mcqs_border">
        <div className="parent_input">
          <div className="order-number">
            <span className="order-number-box">{option.order}</span>
          </div>
          <textarea
            id={`textarea-${questionIndex}-${optionIndex}`}
            className="orderlist-input"
            placeholder={
              option.type === "text" ? `Add text` : `Add text (optional)`
            }
            rows={1}
            value={option.text}
            onChange={(e) => handleInputChange(e, questionIndex, optionIndex)}
            style={{
              height: `${textareaHeights[questionIndex][optionIndex]}px`,
            }}
          />
          <div className="dropdown-arrow">
            <img src={angleDown} alt="down arrow" />
          </div>
        </div>

        {(option.type === "image" || option.type === "video") && (
          <div>
            <div className="image_parent">
              <div className="order-number"></div>
              {option.imageFile ? (
                <div className="input_image">
                  <img
                    className="upload_image_order"
                    src={option.imageFile}
                    alt=""
                  />
                </div>
              ) : option.videoFile ? (
                <div className="input_image video_order_list">
                  {isS3Url(option.videoFile) ? (
                    <video controls className="video_order_list">
                      <source src={option.videoFile} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : isYouTubeUrl(option.videoFile) ? (
                    <iframe
                      className="video_order_list"
                      style={{ borderRadius: "4px" }}
                      src={option.videoFile}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    <div
                      className="input_image"
                      onClick={() =>
                        handleVideoOptionClick(questionIndex, optionIndex)
                      }
                    >
                      <img
                        src={video}
                        alt="video"
                        style={{ display: "block" }}
                      />
                      <img src={plusCricle} className="plus_icon" alt="plus" />
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="input_image"
                  onClick={() => {
                    if (option.type === "image") {
                      handleImageOptionClick(questionIndex, optionIndex);
                    } else if (option.type === "video") {
                      handleVideoOptionClick(questionIndex, optionIndex);
                    }
                  }}
                >
                  <img
                    src={option.type === "image" ? imagedrage : video}
                    alt="image"
                    style={{ display: "block" }}
                  />
                  <img src={plusCricle} className="plus_icon" alt="plus" />
                </div>
              )}
              <div className="dropdown-arrow"></div>
            </div>
          </div>
        )}

        {option.type === "audio" && (
          <div className="image_parent">
            <div className="order-number"></div>
            {option.audioFile ? (
              <div className="audio_boarder_order">
                <div className="deflat_content audio_file_parent">
                  <span className="audio_file">{option.audioFile.name}</span>
                  <span className="audio_size">
                    {formatTime(option.audioDuration)} (
                    {Math.round(option.audioFile.size / (1024 * 1024))} MB)
                  </span>
                </div>

                <AudioPlayer
                  ref={audioRef}
                  style={{ width: "100%" }}
                  src={URL.createObjectURL(option.audioFile)}
                  customAdditionalControls={[]}
                  customVolumeControls={[]}
                  showJumpControls={false}
                  customProgressBarSection={[
                    RHAP_UI.CURRENT_TIME,
                    <div className="slash_time" key="slash">
                      /
                    </div>,
                    RHAP_UI.DURATION,
                    RHAP_UI.PROGRESS_BAR,
                  ]}
                />
              </div>
            ) : (
              <div
                className="input_image input_audio"
                onClick={() =>
                  handleAudioOptionClick(questionIndex, optionIndex)
                }
              >
                <img src={audioIcon} alt="audio" style={{ display: "block" }} />
                <img src={plusCricle} className="plus_icon" alt="plus" />
              </div>
            )}
            <div className="dropdown-arrow"></div>
          </div>
        )}
      </div>
    </>
  );
};

const RenderSavedOption = ({
  option,
  isS3Url,
  isYouTubeUrl,
  audioRef,
  isEditing,
}) => {
  return (
    <>
      <div className="parent_input_with_image">
        <div className="parent_input">
          <div className="order-number order-number_save">
            <span className="order-number-box order-number-box_save checkbox_border_color">
              {option.order}
            </span>
          </div>
          <div>
            {option.text && (
              <div
                className="orderlist-input option_save_state"
                style={{
                  minHeigh: "32px",
                  height: "auto",
                }}
              >
                {option.text}
              </div>
            )}

            {option.audioFile && (
              <div
                className={`deflat_content audio_file_parent_order audio_child${
                  option.text ? "padding_none " : ""
                }`}
              >
                <span className="audio_file">Audio file</span>
                <span className="view_transcript">View transcript</span>
              </div>
            )}
          </div>
        </div>

        {(option.type === "image" || option.type === "video") && (
          <div>
            <div
              className="image_parent save_image_padding"
              style={{ height: "86px" }}
            >
              {option.imageFile ? (
                <div
                  className={`input_image ${
                    !isEditing ? "grid_image_height" : ""
                  }`}
                >
                  <img
                    className="upload_image_order grid_image_height"
                    src={option.imageFile}
                    alt=""
                  />
                </div>
              ) : option.videoFile ? (
                <div
                  className="input_image video_order_list"
                  style={{ height: "77px" }}
                >
                  {isS3Url(option.videoFile) ? (
                    <video
                      controls
                      className="video_order_list"
                      style={{ height: "77px" }}
                    >
                      <source src={option.videoFile} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : isYouTubeUrl(option.videoFile) ? (
                    <iframe
                      className="video_order_list"
                      style={{ borderRadius: "4px", height: "77px" }}
                      src={option.videoFile}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    <div className="input_image">
                      <img
                        src={video}
                        alt="video"
                        style={{ display: "block" }}
                      />
                      <img src={plusCricle} className="plus_icon" alt="plus" />
                    </div>
                  )}
                </div>
              ) : (
                <div className="input_image" style={{ height: "77px" }}>
                  <img
                    src={option.type === "image" ? imagedrage : video}
                    alt="image"
                    style={{ display: "block" }}
                  />
                  <img src={plusCricle} className="plus_icon" alt="plus" />
                </div>
              )}
            </div>
          </div>
        )}

        {option.type === "audio" && (
          <div
            className={`image_parent save_image_padding ${
              option.type === "audio" ? "remove_padding" : ""
            }`}
          >
            {option.audioFile ? (
              <div className="audio-save_state">
                <AudioPlayer
                  ref={audioRef}
                  style={{ width: "100%" }}
                  src={URL.createObjectURL(option.audioFile)}
                  customAdditionalControls={[]}
                  customVolumeControls={[]}
                  showJumpControls={false}
                  customProgressBarSection={[
                    RHAP_UI.CURRENT_TIME,
                    <div className="slash_time" key="slash">
                      /
                    </div>,
                    RHAP_UI.DURATION,
                    RHAP_UI.PROGRESS_BAR,
                  ]}
                />
              </div>
            ) : (
              <div className="input_image input_audio">
                <img src={audioIcon} alt="audio" style={{ display: "block" }} />
                <img src={plusCricle} className="plus_icon" alt="plus" />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default MultiSelectOption;
